export const SCENES = {
  FIRST_LEVEL: "FirstLevel",
  SECOND_LEVEL: "SecondLevel",
  THIRD_LEVEL: "ThirdLevel",
} as const;
